import { Component, Input, OnInit } from '@angular/core';
import { GenericValue } from 'hisng';
import { ResearchPartner, Business, Address } from 'app/fs/res/common/model/researchPartner/researchPartner';

@Component( {
    selector: 'res-external-organization-create',
    templateUrl: './external-organization-create.component.html'
} )

export class ExternalOrganizationCreateComponent implements OnInit {
    @Input() researchPartner: ResearchPartner;

    public researchPartnerCity: string;
    public researchPartnerCountry: string;
    public researchPartnerDistrict: string;

    /* component ngOnInit */
    ngOnInit() {
        if ( this.researchPartner ) {
            this.researchPartner.business = new Business();
            // initialize address
            if ( this.researchPartner.business.postAddresses == null ) {
                this.researchPartner.business.postAddresses = new Array<Address>( new Address() );
            }
        }
    }

    /**
     * call back implementation of ngModelChange()  to set city - always at position [0]
     */
    public cityChange( event: string ): void {
        this.researchPartner.business.postAddresses[0].city = event;
    }

    /**
     * call back implementation of ngModelChange() to set country - always at position [0]
     */
    public countryChange( event: GenericValue ): void {
        this.researchPartner.business.postAddresses[0].country = event;
    }

    /**
     * call back implementation of ngModelChange() to set district only if country selected is 'Germany' - always at position [0]
     */
    public districtChange( event: GenericValue ): void {
        this.researchPartner.business.postAddresses[0].district = event;
    }

    /** isCountryGermany enable distric choice */
    public isCountryGermany() {
        // check if country is Germany/Deutschland
        if ( this.researchPartner.business.postAddresses[0].country
            && this.researchPartner.business.postAddresses[0].country.text === 'Deutschland' ) {
            return true;
        }
        return false;
    }
}
